import { render, staticRenderFns } from "./nameverify.vue?vue&type=template&id=00900cca&"
import script from "./nameverify.vue?vue&type=script&lang=js&"
export * from "./nameverify.vue?vue&type=script&lang=js&"
import style0 from "./nameverify.vue?vue&type=style&index=0&id=00900cca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports